import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../core/services/auth.service';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'app-header',
    imports: [RouterModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.css'
})
export class HeaderComponent {

  user:any
  role:any
  roles:any[]=[]

  constructor(
    private spinnerService:NgxSpinnerService, 
    private authService:AuthService,
    private router: Router,
    private toastr:ToastrService,
    private lsService:LocalStorageService
  ) { }
  ngOnInit(): void {
    this.user=this.lsService.get(GlobalName.userName)
    this.roles=this.user?.roles ?? []
  }

  /** Initiales affichees dans la pastille, a defaut d'avatar televerse. */
  initials(){
    const name=(this.user?.name ?? '').trim()
    if (!name) return '?'
    return name.split(/\s+/).slice(0,2).map((w:string)=>w.charAt(0).toUpperCase()).join('')
  }

  /** Les roles etaient charges mais jamais affiches. */
  roleLabel(){
    const labels:any={
      adminsys:'Administrateur',
      professeur:'Enseignant',
      parent:'Parent',
      apprenant:'Apprenant',
      comptable:'Comptable',
      rh:'Ressources humaines',
      infirmier:'Infirmier',
      de:'Directeur des études'
    }
    const name=this.roles[0]?.name
    return labels[name] ?? name ?? ''
  }


  logout(){
    this.spinnerService.show()
    this.authService.logout().subscribe((res:any)=>{
      this.lsService.remove(GlobalName.tokenName)
      this.lsService.remove(GlobalName.refreshTokenName)
      this.lsService.remove(GlobalName.expireIn)
      this.lsService.remove(GlobalName.userName)
      this.lsService.remove(GlobalName.exercice)
      this.lsService.remove(GlobalName.currentRoleIndex)
      this.spinnerService.hide()

      this.router.navigate(['/login'])
      this.toastr.success('Déconnexion réussie', 'Connexion');
    },
    (err:any)=>{
      this.spinnerService.hide()
      this.lsService.remove(GlobalName.tokenName)
      this.lsService.remove(GlobalName.refreshTokenName)
      this.lsService.remove(GlobalName.expireIn)
      this.lsService.remove(GlobalName.userName)
      this.lsService.remove(GlobalName.exercice)
      this.lsService.remove(GlobalName.currentRoleIndex)
      this.router.navigate(['/login'])
      this.toastr.error('Session expirée', 'Connexion');

    } 
    )
   
  }
}
